var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPasswUnvisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8369 8.62271C10.8842 8.40155 10.9091 8.17235 10.9091 7.9375C10.9091 6.0975 9.38182 4.60417 7.5 4.60417C7.28633 4.60417 7.07723 4.62342 6.87442 4.66025L5.41775 3.20358C6.08187 3.03003 6.77983 2.9375 7.5 2.9375C10.9091 2.9375 13.8205 5.01083 15 7.9375C14.5588 9.03227 13.8752 10.0076 13.0139 10.7997L10.8369 8.62271Z",
    fill: "#696D73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9861 5.07523C1.1248 5.86734 0.441235 6.84272 0 7.9375C0.405469 8.94354 1.01558 9.84875 1.78019 10.6036C1.84206 10.6646 1.90493 10.7247 1.96879 10.7838C2.9267 11.6699 4.1062 12.3287 5.41771 12.6714C6.08184 12.845 6.77981 12.9375 7.5 12.9375C8.22019 12.9375 8.91816 12.845 9.58229 12.6714C9.92361 12.5822 10.256 12.4716 10.5778 12.3412L11.8371 13.6004C12.2032 13.9665 12.7968 13.9665 13.1629 13.6004C13.529 13.2343 13.529 12.6407 13.1629 12.2746L3.16291 2.27459C2.7968 1.90847 2.2032 1.90847 1.83709 2.27459C1.47097 2.6407 1.47097 3.2343 1.83709 3.60041L2.71572 4.47904C2.46057 4.66379 2.21695 4.86292 1.9861 5.07523ZM7.5 11.2708C7.71368 11.2708 7.9228 11.2516 8.12562 11.2147C8.47606 11.1511 8.80772 11.035 9.11176 10.8751L4.53269 6.29601C4.36218 6.58989 4.23602 6.91153 4.16312 7.25224C4.11579 7.47342 4.09091 7.70264 4.09091 7.9375C4.09091 8.17235 4.11579 8.40154 4.16311 8.62271C4.446 9.94484 5.53086 10.98 6.89679 11.2187C7.09259 11.253 7.29418 11.2708 7.5 11.2708Z",
    fill: "#696D73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswUnvisible);
export default __webpack_public_path__ + "static/media/icon-passw-unvisible.19c2051e2034ee330784ae1cf10097da.svg";
export { ForwardRef as ReactComponent };